export default __webpack_public_path__ + "static/media/roulette-animated.217244ed.webp";